(function($, window){

    $.fn.TimedPopup = function(options) {
      return this.each(function(){
        var $popup = $(this);
        var settings = $.extend({
         cookieValue: 'sent-away',
         expires: 7,
         cookieNameAttr: 'data-timed-popup',
         scrollBlock: $popup.attr('data-timed-popup-scroll-block'),
         selectors: {
          close: '[data-timed-popup-close]'
         },
         beforeDisplay: false
        }, options);


        var cookieName = $popup.attr(settings.cookieNameAttr);
        var cookieVal = Cookies.get(cookieName);

        if(Shopify.designMode) return;
        if(typeof settings.beforeDisplay === 'function' && !settings.beforeDisplay()) return; 

        if(!cookieVal || cookieVal !== settings.cookieValue) {
            $popup.show();
            
            if(settings.scrollBlock) {
              $('body, html').css({overflow: 'hidden'});
            }

          $popup.on('click', settings.selectors.close, function(){
            Cookies.set(cookieName, settings.cookieValue, { expires: settings.expires });
            if(settings.scrollBlock) {
              $('body, html').css({overflow: 'auto'});
            }
          });
        }
      });
    }


    $(document).ready(function(){
        var $timedPopups = $('[data-timed-popup]');
        if(!$timedPopups.length) return;

        var cookiesJs = document.createElement('SCRIPT');
        cookiesJs.id = 'cookies-js-script';
        cookiesJs.src = 'https://cdn.jsdelivr.net/npm/js-cookie@rc/dist/js.cookie.min.js'
        cookiesJs.onload = function(){
            $timedPopups.TimedPopup({
              beforeDisplay: function(){
                // Display only when website url is homepage
                return window.location.pathname === '/' && !window.location.search;
              }
            });
        };

        document.body.appendChild(cookiesJs);
    });
  })(jQuery, window);